/** Stable lesson-number list for progress-batch query keys and API payloads. */
export function normalizeLessonNumbers(values: readonly number[]): number[] {
  return Array.from(
    new Set(values.filter((value) => Number.isInteger(value) && value > 0)),
  ).sort((a, b) => a - b);
}
